import React, { useState, useEffect } from 'react';
import bem from 'utils/bem'
import { useFormikContext } from 'formik';
import { isValidPhoneNumber } from 'react-phone-number-input';
import Text from 'components/Text';
import Spinner from 'components/Spinner';
import FormikPhoneField from 'forms/fields/PhoneField/FormikPhoneField';
import Model from '../../../../model';

import 'react-phone-number-input/style.css'
import './index.sass';
import { observer } from 'mobx-react-lite';
import Icon from 'components/Icon';

const { block, el } = bem('form-field', 'customer-phone-field');

const RegisterPhoneField = ({ className, name = 'customerPhone', ...rest}) => {

    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState(null);

    const {
        values: { customerPhone: value },
    } = useFormikContext();

    useEffect(() => {
        if (value && isValidPhoneNumber(value)) {
            setLoading(true)
            Model.user.getCustomerInfoByPhone(value).then(({name}) => {
                setLoading(false);
                if (name) {
                    setError(`Пользователь с таким телефоном уже существует`);
                }
            })
        } else {
            setError(null);
        }
    }, [value]);

    return (
        <div className={block()}>
            <div className={el('loading-container', {'disabled': loading})} >
                <FormikPhoneField {...rest} loading={loading} error={error}/>
                { loading && <Spinner/> }
            </div>
        </div>
    )
};

export default observer(RegisterPhoneField);
